import React from 'react';
import { unescape } from 'lodash';

import style from '../index.module.css';

import Placeholder from '../../../static/images/placeholder.svg';

type AuctionCardProps = {
    auctionDetails?: string;
    details?: string;
    endDate?: number;
    image?: string;
    imageAltText?: string;
    promoType: string;
    startDate?: number;
    title?: string;
    url?: string;
};

const AuctionCard = ({
    auctionDetails,
    details,
    endDate,
    image,
    imageAltText,
    promoType,
    startDate,
    title,
    url,
}: AuctionCardProps) => {
    const currentDate = Date.now();

    return (
        <div className={style.cardPromo} data-type={promoType}>
            <div className={style.imageContainer}>
                {/* Remove tabindex so users don't have to tab through cards twice (they are both the same link) */}
                <a href={url} tabIndex={-1}>
                    <img src={image ? image : Placeholder} alt={imageAltText ? imageAltText : unescape(title)} />
                </a>
            </div>

            <div className="info">
                <a href={url}>
                    <h3 className={`${style.title} ${style.twoLineClamp}`}>{unescape(title)}</h3>

                    {auctionDetails && <div className={style.detail}>{auctionDetails}</div>}

                    {details && <div className={style.sold}>{details}</div>}

                    <div className={style.cta}>
                        {currentDate > startDate
                            ? currentDate <= endDate
                                ? 'Bid on lots'
                                : 'View results'
                            : 'Preview'}
                    </div>
                </a>
            </div>
        </div>
    );
};

export default AuctionCard;
